import * as React from 'react';
import classnames from 'classnames';
import * as styles from './Main.module.scss';

export interface MainProps {
    classes?: Partial<typeof styles>;
    fullWidth?: boolean;
    children: React.ReactNode;
}

export default function Main({ classes, children, fullWidth }: MainProps) {
    return (
        <main
            id="main"
            className={classnames(styles.root, classes?.root, {
                [styles.container]: !fullWidth,
            })}
        >
            {children}
        </main>
    );
}
